import * as React from 'react';
import { CopyrightConfig } from './type';

export default function Copyright({ company, text, disabled }: CopyrightConfig) {
    return !disabled && <div className="copyright">{text || `Copyright © ${company || ''} 2015-${new Date().getFullYear()} ${window.crm_version || ''}`}</div>;
}
